module.exports = __webpack_public_path__ + "static/media/undraw_Designer_re_5v95.848477a4.png";